import React from 'react';
import { Panel } from 'rsuite';

import './styles.css';

/**
 * Custom Panel component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').PanelProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomPanel component.
 */

export function CustomPanel({ children, ...rest }) {
  return (
    <Panel {...rest} className="custom-Panel">
      {children}
    </Panel>
  );
}
